import {
  type AssertionLoginResult,
  ChallengeType,
  type RequestAttestation,
} from '~/interfaces/auth';
import { LoginHandler } from './login-handler';

export class EmailHandler extends LoginHandler<
  Omit<RequestAttestation, 'data'>,
  AssertionLoginResult
> {
  protected transformRequestBody(
    body: Omit<RequestAttestation, 'data'>,
  ): AssertionLoginResult {
    if (!body.assert.code || !body.alias) {
      throw new Error('Invalid request body');
    }

    return {
      assertion_result: {
        challengeType: ChallengeType.OTP,
        alias: body.alias,
        value: {
          code: body.assert.code,
          email: body.alias,
        },
      },
      extra_context: {},
    };
  }
}
